export default __webpack_public_path__ + "static/128kbps_YearlingsBobtail-c1f6a395cfe79ff1268031aed51ec7c7.mp3";